import { useBreakpoints } from "core/hooks/useBreakpoints";
import { BrcyLogo, type LogoType } from "core/hooks/useLogos";

export function BrandLogo({
  logoStyle: overrideLogoStyle,
}: {
  logoStyle?: LogoType;
}) {
  const { isDesktop } = useBreakpoints();
  const logoStyle = overrideLogoStyle ?? (isDesktop ? "Desktop" : "Mobile");
  return <BrcyLogo type={logoStyle} width={200} height={70} />;
}
